import { Component } from '@angular/core';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UtilitiesService } from 'src/app/services/utilities/utilities.service';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { handleFileUploaded, handleFileUploadError } from 'src/app/shared/components/upload-input/file-upload-helper';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { PaymentModalComponent } from 'src/app/shared/modals/payment-modal/payment-modal.component';

@Component({
  selector: 'app-manual-reconciliation',
  standalone: false,
  templateUrl: './manual-reconciliation.component.html',
  styleUrl: './manual-reconciliation.component.scss'
})
export class ManualReconciliationComponent {
  isSubmitting: boolean;
  searchPaymentResultsEmpty: any;
  isSearchingPayment: any;
  searchedPaymentDataNotFound: any;
  errorFetchingPaymentData: any;

  selectedPayments: number[] = [];
  paymentDataList: any[] = [];
  totalPaymentAmount: number = 0;

  assessmentDataList: any[] = [];

  assessmentForm: FormGroup;

  searchAssessmentResultsEmpty: any;
  isSearchingAssessment: any;
  searchedAssessmentDataNotFound: any;
  errorFetchingAssessmentData: any;

  totalAssessmentAmount: number = 0;


  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private dialog: MatDialog,
    private utilitiesService: UtilitiesService,
    private router: Router,
    private authService: AuthService,
    private location: Location
  ) { }

  showErrorMessages: boolean = false;

  form: FormGroup;

  wardList: any;

  ngOnInit(): void {

    this.initializeForm();

    this.initializeAssessmentForm()
  }


  totalAmounts(): void {
    this.totalPaymentAmount = 0;
    this.selectedPayments.forEach(id => {
      const item = this.paymentDataList.find(x => x.id === id);
      if (item?.amount) {
        this.totalPaymentAmount += item.amount;
      }
    });

  }


  get isAllPaymentSelected(): boolean {
    return this.paymentDataList.length > 0 &&
           this.paymentDataList.every(item => this.selectedPayments.includes(item.id));
  }

  isPaymentSelected(id: number): boolean {
    return this.selectedPayments.includes(id);
  }

  togglePaymentSelection(id: number): void {
    const index = this.selectedPayments.indexOf(id);
    if (index > -1) {
      this.selectedPayments.splice(index, 1);
    } else {
      this.selectedPayments.push(id);
    }
    this.totalAmounts();
  }

  togglePaymentSelectAll(event: any): void {
    if (event.target.checked) {
      this.selectedPayments = this.paymentDataList.map(item => item.id);
    } else {
      this.selectedPayments = [];
    }
    this.totalAmounts();
  }






  initializeForm() {
    this.form = this.formBuilder.group({

      paymentType: ['', [Validators.required]],
      asin: ['', [Validators.required]],
      paymentReference: [''],

    });

    this.form.valueChanges.subscribe(() => {
      this.totalPaymentAmount = 0;
      this.paymentDataList = [];
      this.selectedPayments = []
       this.totalAssessmentAmount = 0;
       this.assessmentDataList = [];

       this.initializeAssessmentForm()
    });
  }


  initializeAssessmentForm(){
    this.assessmentForm = this.formBuilder.group({

      assessmentId: ['', [Validators.required]],
      type: ['', [Validators.required]],

    });

    this.assessmentForm.valueChanges.subscribe(() => {
      this.totalAssessmentAmount = 0;
       this.assessmentDataList = [];
    });
  }


  verifyAssessment() {

    this.assessmentDataList = []
    this.searchedAssessmentDataNotFound = false;
    this.errorFetchingAssessmentData = false
    this.isSearchingAssessment = true;

    const assessmentId = this.assessmentForm.value?.assessmentId

    const asin = this.form.value?.asin

    const type = this.assessmentForm.value?.type

    this.apiService
      .get('/reconciliation/unpaid/assessment?asin=' + asin + '&assessmentId=' + assessmentId + '&type=' + type)
      .pipe(
        finalize(() => {
          this.isSearchingAssessment = false;
        })
      )
      .subscribe(
        (response: any) => {


          if(!response){

            this.searchedAssessmentDataNotFound = true;

          }else{

            if(response?.amount > this.totalPaymentAmount){

              this.openErrorModal("Insufficient Payment Amount")

            }else{

              this.totalAssessmentAmount = response?.amount
              this.assessmentDataList.push(response)
            }
          }



        },
        (error) => {
          this.openErrorModal(error?.message);

          this.errorFetchingAssessmentData = true
        }
      );
  }


  reconcile(){

    const req = {

      assessmentId: this.assessmentForm.value?.assessmentId,
      paymentIds: [...this.selectedPayments],
      type: this.assessmentForm.value?.type,
      asin: this.form.value?.asin

    }

    let url = ""

    if(this.form.get('paymentType').value == 'Tax Credit'){

      url = '/reconciliation/reconciliation/with/credit'

    }else{

      url = '/reconciliation/reconciliation'

    }

    this.apiService
      .post(url, req)
      .pipe(
        finalize(() => {
          this.isSearchingPayment = false;
        })
      )
      .subscribe(
        (response) => {

          this.openSuccessModal(response?.message)

        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );

  }


  searchPayments() {
    this.paymentDataList = []
    this.searchedPaymentDataNotFound = false;
    this.errorFetchingPaymentData = false
    this.isSearchingPayment = true;
    this.form.markAsPristine();

    var formData: any = new FormData();
    const formValues = this.form.value;


    let url = ""

    if(this.form.get('paymentType').value == 'Tax Credit'){
        url = '/reconciliation/tax-credit/details'
    }

    if(this.form.get('paymentType').value == 'Bank Transfer'){
      url = '/reconciliation/unused/payment/search'
  }

    this.apiService
      .post(url, formValues)
      .pipe(
        finalize(() => {
          this.isSearchingPayment = false;
        })
      )
      .subscribe(
        (response) => {

          if(this.form.get('paymentType').value == 'Tax Credit'){

            this.paymentDataList.push(response);

            this.totalPaymentAmount = response?.creditAmount
          }else{
            this.paymentDataList = response;
          }

          if (this.paymentDataList.length < 1) {
            this.searchedPaymentDataNotFound = true;
          }



        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingPaymentData = true
        }
      );
  }


  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      window.location.reload()
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  openConfirmModal() {
    this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'operation-modal', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Are you sure you want to reconcile htis assessment/application?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {

          this.reconcile()

        },
        onCancel: () => { },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }


  back() {
    this.location.back()
  }
}
